import { GlobalState } from '../../reducers';

export const getIsAuthenticated = (state: GlobalState) =>
  state?.auth?.isAuthenticated || false;
